module.exports = __webpack_public_path__ + "media/images/front/sp_tl-menu_active-a09669a4cca86d1b5d00b5753f5dac7f.png";